import * as Sentry from '@sentry/angular';
import { environment } from '../environments/environment';
import { readRunningBuild } from './core/services/app-update.service';
import { installChunkErrorHandlers, tagChunkLoadEvent } from './core/chunk-reload';

// Set by the deploy (index.html app-version meta); absent in local builds.
const build = readRunningBuild();

// Before Sentry.init, so these run ahead of Sentry's global handlers (MP-5600).
// main.ts imports this file first.
installChunkErrorHandlers();

Sentry.init({
  dsn: environment.sentryDsn,
  environment: environment.production ? 'smtx-manager-panel-production' : 'smtx-manager-panel-dev',
  release: build ? `manager@${build.version}` : undefined,
  initialScope: { tags: { app: 'manager', build_sha: build?.sha || 'unknown' } },
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      maskAllInputs: true,
      blockAllMedia: true,
    }),
  ],
  tracesSampleRate: 0.2,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  tracePropagationTargets: [environment.projectsUrl, environment.apiBaseAddress],

  beforeSend(event, hint) {
    // filter certain events, attach user info
    try {
      const userData = localStorage.getItem('userInfo');
      if (userData) {
        const user = JSON.parse(userData);
        Sentry.setTags({
          application_id: user.applicationId,
          sslDomain: user.sslDomain || '',
          firstName: user.firstName || '',
          lastName: user.lastName || '',
          userId: user.userId || '',
          email: user.email || '',
          userName: user.userName || '',
          roleName: user.roleName || '',
        });
      }
    } catch (e) {
      console.warn('Sentry: Failed to attach user info', e);
    }

    return tagChunkLoadEvent(event, hint?.originalException);
  },
});
